/*
 * @Author: cc
 * @Date: 2020-04-02 13:23:33
 * @LastEditTime: 2020-12-31 11:30:45
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\trill\draftBox\draftBoxRouter.js
 * @Description:  抖音废稿箱路由
 */
'use strict';
angular.module('editTrillDraftBoxRouterModule', [])
    . config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('front.editctr.trill.draftbox', {
            url: '/draftbox?account&channelid', // account->账号
            views: {
                'main@front.editctr': {
                    templateUrl: './editingCenter/trill/draftBox/main.html',
                    controller: 'EditTrillDraftBoxCtrl'
                }
            }
        });
    }]);
